// User content API (watch history, discover) – requires auth
// Backend paths: /users/watch-history, /feed (no /api prefix)

import { apiGet } from '../api-client'
import type { Video } from '../types/api'

/** Watch history entry from GET /users/watch-history (filmId, episodeId, coverImage, etc.) */
export interface WatchHistoryEntry {
  id: string
  filmId?: string
  filmTitle?: string
  episodeId?: string
  episodeNumber?: number
  episodeTitle?: string
  coverImage?: string
  progress?: number
  duration?: number
  watchedAt: string
}

export interface WatchHistoryResponse {
  items: WatchHistoryEntry[]
  total: number
  page: number
  limit: number
}

export interface DiscoverResponse {
  videos: Video[]
}

/** Backend returns { items, nextToken, totalCount } */
interface WatchHistoryBackendResponse {
  items?: WatchHistoryEntry[]
  nextToken?: string | null
  totalCount?: number
}

/** Backend /feed returns { items, nextToken, totalCount } */
interface FeedBackendResponse {
  items?: Video[]
  nextToken?: string | null
  totalCount?: number
}

export async function getWatchHistory(params?: {
  page?: number
  limit?: number
}): Promise<WatchHistoryResponse> {
  const query = new URLSearchParams()
  if (params?.limit != null) query.set('limit', String(params.limit))
  const qs = query.toString()
  const res = await apiGet<WatchHistoryBackendResponse>(
    `/users/watch-history${qs ? `?${qs}` : ''}`
  )
  const items = res.items ?? []
  const limit = params?.limit ?? 6
  return {
    items,
    total: res.totalCount ?? items.length,
    page: 0,
    limit,
  }
}

export async function getDiscover(limit: number = 10): Promise<DiscoverResponse> {
  const qs = new URLSearchParams({ limit: String(Math.min(50, limit)) })
  const res = await apiGet<FeedBackendResponse>(`/feed?${qs}`)
  return {
    videos: res.items ?? [],
  }
}
